import Employee from './Employee'
import AppSetting from './AppSetting'
import EmployeeActivationRequest from './EmployeeActivationRequest'

export class AuthenticationResult {
  Success: boolean;
  Employee: Employee;
  Location: string;
  AppSettings: AppSetting[];
  EmployeeActivationRequests: EmployeeActivationRequest[];
}

export default AuthenticationResult;